import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, App as AntdApp } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import MainLayout from './components/common/MainLayout';
import Dashboard from './pages/Dashboard';
import Courses from './pages/Courses';
import Exams from './pages/Exams';
// import MyCourses from './pages/MyCourses';
import CourseDetails from './pages/CourseDetails';
import CourseLearning from './pages/CourseLearning';
import LessonViewer from './pages/LessonViewer';
import ExamDetails from './pages/ExamDetails';
import ExamTaking from './pages/ExamTaking';
import ExamResult from './pages/ExamResult';
import Profile from './pages/Profile';
import SharedFiles from './pages/SharedFiles';
import ClassAssignments from './pages/ClassAssignments';
import Login from './pages/Login';
import Register from './pages/Register';
import ProtectedRoute from './components/auth/ProtectedRoute';
import authService from './services/authService';
import './App.css';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const theme = {
  token: {
    colorPrimary: '#1890ff',
    borderRadius: 6,
    colorBgContainer: '#ffffff',
  },
};

function App() {
  const isAuthenticated = authService.isAuthenticated();

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider theme={theme}>
        <AntdApp>
          <Router>
            <Routes>
              {/* Public routes */}
              <Route 
                path="/login" 
                element={
                  isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />
                } 
              />
              <Route 
                path="/register" 
                element={
                  isAuthenticated ? <Navigate to="/dashboard" replace /> : <Register />
                } 
              />
              
              {/* Protected routes */}
              <Route 
                path="/*" 
                element={
                  <ProtectedRoute>
                    <MainLayout>
                      <Routes>
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/courses" element={<Courses />} />
                        <Route path="/exams" element={<Exams />} />
                        {/* <Route path="/my-courses" element={<MyCourses />} /> */}
                        <Route path="/course/:courseId" element={<CourseDetails />} />
                        <Route path="/course/:courseId/learn" element={<CourseLearning />} />
                        <Route path="/lesson/:lessonId" element={<LessonViewer />} />
                        <Route path="/course/:courseId/lesson/:lessonId" element={<LessonViewer />} />
                        <Route path="/exam/:examId" element={<ExamDetails />} />
                        <Route path="/exam/:examId/take" element={<ExamTaking />} />
                        <Route path="/exam/:examId/results" element={<ExamResult />} />
                        <Route path="/shared-files" element={<SharedFiles />} />
                        <Route path="/assignments" element={<ClassAssignments />} />
                        <Route path="/profile" element={<Profile />} />
                      </Routes>
                    </MainLayout>
                  </ProtectedRoute>
                } 
              />
            </Routes>
          </Router>
        </AntdApp>
      </ConfigProvider>
      {/* React Query DevTools */}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
export default App;

